import AntSlider from "antd/es/slider";
import styled from "styled-components";
import { SliderRangeProps } from "antd/es/slider";

const StyledSlider = ({ ...props }: SliderRangeProps) => {
  // @ts-ignore
  return <Slider {...props} />;
};

export default StyledSlider;

const Slider = styled(AntSlider)`
  .ant-slider-mark-text {
    color: ${(p) => p.theme.colors.textColor};
  }
  .ant-slider-track {
    background-color: ${(p) => p.theme.colors.primaryBlue};
    &:not(.ant-tooltip-open) {
      background: ${(p) => p.theme.colors.primaryBlue}!important;
    }
  }
  .ant-slider-handle {
    border-color: ${(p) => p.theme.colors.primaryBlue};
    &:not(.ant-tooltip-open) {
      border-color: ${(p) => p.theme.colors.primaryBlue}!important;
    }
  }
  .ant-slider-dot-active {
    background-color: ${(p) => p.theme.colors.primaryBlue};
    border: none;
    width: 10px;
    height: 10px;
    top: -3px;
  }
  &.ant-slider-with-marks {
    margin-bottom: 0 !important;
  }
  .ant-slider-rail {
    background-color: ${(p) => p.theme.colors.mediumBorderGrey}!important;
  }
  .ant-slider-dot:not(.ant-slider-dot-active) {
    border-color: ${(p) => p.theme.colors.mediumBorderGrey}!important;
    background-color: ${(p) => p.theme.colors.cardBgColor}!important;
  }
  .ant-slider-handle::after {
    box-shadow: 0 0 0 2px ${(p) => p.theme.colors.primaryBlue}!important;
  }
  .ant-slider-handle:hover::after {
    box-shadow: 0 0 0 4px ${(p) => p.theme.colors.primaryBlue}!important;
  }
  .ant-slider-handle::after {
    background: ${(p) => p.theme.colors.cardBgColor}!important;
  }
`;
